exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loop[data-v-9351b66a] {\n    transition: all 0.5s;\n    transform-origin: 50% 20px;\n}\nsvg:hover .loop[data-v-9351b66a],\nsvg:focus .loop[data-v-9351b66a],\nsvg:active .loop[data-v-9351b66a] {\n    transform: rotate(-20deg);\n}\n", ""]);

// exports
